import { Message, Notification, MessageBox } from 'element-ui'

function successNotify(content, duration) {
  let d = 0
  if (duration) {
    d = duration
  }
  Notification({
    title: '成功',
    message: content,
    type: 'success',
    showClose: true,
    duration: d,
  })
}
function warningNotify(content, duration) {
  let d = 0
  if (duration) {
    d = duration
  }
  Notification({
    title: '警告',
    message: content,
    type: 'warning',
    showClose: true,
    duration: d,
  })
}
function infoNotify(content, duration) {
  let d = 0
  if (duration) {
    d = duration
  }
  Notification({
    title: '提示',
    message: content,
    type: 'info',
    showClose: true,
    duration: d,
  })
}
function errorNotify(content, duration) {
  let d = 0
  if (duration) {
    d = duration
  }
  Notification({
    title: '错误',
    message: content,
    type: 'error',
    showClose: true,
    duration: d,
  })
}
function successMsg(content) {
  Message({
    showClose: true,
    message: content,
    type: 'success',
  })
}
function errorMsg(content) {
  Message({
    showClose: true,
    message: content,
    type: 'error',
  })
}
function warningMsg(content) {
  Message({
    showClose: true,
    message: content,
    type: 'warning',
  })
}
function confirm(content, type, thenCallback, cancelCallback) {
  MessageBox.confirm(content, '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: type,
  })
    .then(thenCallback)
    .catch(cancelCallback ? cancelCallback : () => {})
}

export default {
  confirm,
  warningMsg,
  errorMsg,
  successMsg,
  errorNotify,
  infoNotify,
  warningNotify,
  successNotify
}
